<template>
  <div class="search-input-container">
    <div class="search-input-wrapper">
      <vs-icon :icon="icon" class="search-icon" />
      <input
        :value="value"
        :placeholder="placeholder"
        class="search-input"
        @input="onInput"
        @keyup.enter="onEnter"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "検索",
    },
    icon: {
      type: String,
      default: "search",
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    onEnter() {
      this.$emit("enter", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.search-input-container {
  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    border: 1px solid $aisea-mouse-gray;
    border-radius: 5px;
    background-color: $aisea-pure-white;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus-within {
      border-color: #2d9cdb;
      box-shadow: 0 0 0 2px rgba(45, 156, 219, 0.1);
    }

    .search-icon {
      position: absolute;
      left: 0.75rem;
      color: $aisea-gray-black;
      font-size: 18px;
      pointer-events: none;
    }

    .search-input {
      width: 100%;
      padding: 0.6rem 0.75rem 0.6rem 2.5rem;
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
      color: $aisea-dark-gray;
      background-color: transparent;
      border: none;
      outline: none;

      &::placeholder {
        color: $aisea-mouse-gray;
      }
    }
  }
}
</style>
